import React, {memo} from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Chip from '@/components/Common/Chip';
import parse from 'html-react-parser';
import MUIContainer from '@/components/MUI-Components/MUI-Container';

const DevelopersKeySkill = (props: any) => {
    const {heading, subheading, data} = props;
    return (
        <Box>
            <MUIContainer>
                <Box className="spectrum-header-wrapper" mb={3}>
                    <Typography className="spectrum-heading color-black text-align-left" component="h3">
                        {parse(heading)}
                    </Typography>
                    <Box className="divder-wrapper">
                        <hr className="divider-line divider-line-left" />
                    </Box>
                    <Box className="sub-heading-box ">
                        <Typography className="spectrum-sub-heading text-align-left color-black">{parse(subheading)}</Typography>
                    </Box>
                </Box>
                <Grid container sx={{display: 'flex'}} spacing={2} justifyContent="center">
                    {data?.map((item: any, index: number) => (
                        <Grid item xs={'auto'} key={index + 1}>
                            <Chip className="developer-skill-heading">{parse(item.heading)}</Chip>
                        </Grid>
                    ))}
                </Grid>
            </MUIContainer>
        </Box>
    );
};

export default memo(DevelopersKeySkill);
